import { Outlet, useOutletContext } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import BlockedPeriodPolicyDetails from 'modules/timeoff/components/BlockedPeriod/PolicyDetails'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const BlockedPeriodsDetailsPage = () => {
  const { back, blockedPeriodsPolicy, loading, isNotFound } = useOutletContext<RouteContextParams>()

  useEffect(() => {
    track(trackingEvents.timeoff.blockedPeriods.modifyBlockedPeriodStart)
  }, [])

  return (
    <BlockedPeriodPolicyDetails
      loading={loading}
      isNotFound={isNotFound}
      policy={blockedPeriodsPolicy}
      back={back}
    >
      <Outlet context={{ isNotFound, blockedPeriodsPolicy, loading }} />
    </BlockedPeriodPolicyDetails>
  )
}

export default BlockedPeriodsDetailsPage
